var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _c("h4", { staticClass: "highlight-color" }, [
          _vm._v(_vm._s(_vm.$t("message.register")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "highlight-color" }, [
          _vm._v(_vm._s(_vm.$t("message.intro2")))
        ])
      ]),
      _vm._v(" "),
      _vm.$store.state.app.error_message
        ? _c(
            "div",
            {
              staticClass: "col-md-6 form p-0",
              staticStyle: { background: "none" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "alert alert-danger m-0",
                  attrs: { role: "alert" }
                },
                [
                  _vm.$store.state.app.error_message ==
                  "This email is already taken"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("message.thisemailisalreadytaken"))
                        )
                      ])
                    : _vm.$store.state.app.error_message ==
                      "I was expecting at least 6 chars in password"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.passwordmustbeatleast6characters")
                          )
                        )
                      ])
                    : _c("span", [
                        _vm._v(_vm._s(_vm.$store.state.app.error_message))
                      ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.progress.active == 0
        ? [
            _c("div", { staticClass: "col-md-6 form" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("message.labelstoreandcompany")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.shop_name,
                      expression: "form.shop_name"
                    }
                  ],
                  ref: "shop_name",
                  staticClass: "form-control",
                  class: [{ "is-invalid": _vm.state.is_invalid_shop_name }],
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.shop_name },
                  on: {
                    keyup: function($event) {
                      _vm.form.shop_name.trim().length == 0
                        ? (_vm.state.is_invalid_shop_name = true)
                        : (_vm.state.is_invalid_shop_name = false)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "shop_name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("message.busform")) + ":")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-1" },
                  [
                    _c(
                      "vs-radio",
                      {
                        staticStyle: {
                          "justify-content": "left",
                          margin: "0",
                          "font-size": "var(--font-size)"
                        },
                        attrs: { vsValue: "1" },
                        model: {
                          value: _vm.form.business_form_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "business_form_id", $$v)
                          },
                          expression: "form.business_form_id"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("business.form.1")) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "vs-radio",
                      {
                        staticStyle: {
                          "justify-content": "left",
                          margin: "0",
                          "font-size": "var(--font-size)"
                        },
                        attrs: { vsValue: "2" },
                        model: {
                          value: _vm.form.business_form_id,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "business_form_id", $$v)
                          },
                          expression: "form.business_form_id"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("business.form.2")) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.hasRefCode
                ? _c("div", { staticClass: "form-group" }, [
                    _c("hr"),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.codediscount")) + ":")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { disabled: true, type: "text" },
                        domProps: { value: _vm.$route.query.refcode }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "mt-2",
                        staticStyle: { "font-size": "13px" }
                      },
                      [
                        _vm.partner.loading
                          ? _c("p", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("message.checkingcodediscount")
                                  ) +
                                  "\n          "
                              )
                            ])
                          : _vm.hasPartnerId
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("message.codediscountisvalid", {
                                    discount_rate: _vm.partner.discountRate,
                                    month_period:
                                      _vm.partner.discountMonthPeriod
                                  })
                                )
                              }
                            })
                          : _c("p", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("message.codediscountisinvalid")
                                  ) +
                                  "\n          "
                              )
                            ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("message.business_type")) + ":")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.business_type_code,
                        expression: "form.business_type_code"
                      }
                    ],
                    staticClass: "form-select custom-select",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "business_type_code",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("placeholder.select")) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.form.business_form_id == "1"
                      ? _vm._l(_vm.business_form_option_store, function(
                          group,
                          groupIndex
                        ) {
                          return _c(
                            "optgroup",
                            { key: groupIndex, attrs: { label: group.label } },
                            _vm._l(group.options, function(
                              option,
                              optionIndex
                            ) {
                              return _c(
                                "option",
                                {
                                  key: optionIndex,
                                  domProps: { value: option.value }
                                },
                                [_vm._v(_vm._s(option.text))]
                              )
                            }),
                            0
                          )
                        })
                      : _vm._l(_vm.business_form_option_compay, function(
                          option,
                          index
                        ) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: option.value } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(option.text) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "custom" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.otherbusinesstype")) +
                          "\n          "
                      )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.form.business_type_code == "custom"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.business_type_code_custom,
                          expression: "form.business_type_code_custom"
                        }
                      ],
                      ref: "custom-bus-type",
                      staticClass: "form-control mt-2",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.business_type_code_custom },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.form,
                            "business_type_code_custom",
                            $event.target.value
                          )
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              (_vm.form.business_type_code &&
                _vm.form.business_type_code != "custom") ||
              _vm.form.business_type_code_custom != null
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.recommendedapps")) + ":")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex flex-column mt-1",
                        staticStyle: { gap: "8px" }
                      },
                      [
                        _c("BaseCheckbox", {
                          attrs: {
                            label: _vm.$t("business.interesting.POS"),
                            value: "POS"
                          },
                          model: {
                            value: _vm.form.interesting.POS,
                            callback: function($$v) {
                              _vm.$set(_vm.form.interesting, "POS", $$v)
                            },
                            expression: "form.interesting.POS"
                          }
                        }),
                        _vm._v(" "),
                        _c("BaseCheckbox", {
                          attrs: {
                            label: _vm.$t("business.interesting.MENU_ONLINE"),
                            value: "MENU_ONLINE"
                          },
                          model: {
                            value: _vm.form.interesting.MENU_ONLINE,
                            callback: function($$v) {
                              _vm.$set(_vm.form.interesting, "MENU_ONLINE", $$v)
                            },
                            expression: "form.interesting.MENU_ONLINE"
                          }
                        }),
                        _vm._v(" "),
                        _c("BaseCheckbox", {
                          attrs: {
                            label: _vm.$t("business.interesting.INVENTORY"),
                            value: "INVENTORY"
                          },
                          model: {
                            value: _vm.form.interesting.INVENTORY,
                            callback: function($$v) {
                              _vm.$set(_vm.form.interesting, "INVENTORY", $$v)
                            },
                            expression: "form.interesting.INVENTORY"
                          }
                        }),
                        _vm._v(" "),
                        _vm.form.business_form_id == "2"
                          ? _c("BaseCheckbox", {
                              attrs: {
                                label: _vm.$t("business.interesting.SO_PO_INV"),
                                value: "SO_PO_INV"
                              },
                              model: {
                                value: _vm.form.interesting.SO_PO_INV,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.interesting,
                                    "SO_PO_INV",
                                    $$v
                                  )
                                },
                                expression: "form.interesting.SO_PO_INV"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.business_form_id == "2"
                          ? _c("BaseCheckbox", {
                              attrs: {
                                label: _vm.$t("business.interesting.CRM"),
                                value: "CRM"
                              },
                              model: {
                                value: _vm.form.interesting.CRM,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.interesting, "CRM", $$v)
                                },
                                expression: "form.interesting.CRM"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("BaseCheckbox", {
                          attrs: {
                            label: _vm.$t("business.interesting.ACCOUNTING"),
                            value: "ACCOUNTING"
                          },
                          model: {
                            value: _vm.form.interesting.ACCOUNTING,
                            callback: function($$v) {
                              _vm.$set(_vm.form.interesting, "ACCOUNTING", $$v)
                            },
                            expression: "form.interesting.ACCOUNTING"
                          }
                        }),
                        _vm._v(" "),
                        _vm.form.business_form_id == "2"
                          ? _c("BaseCheckbox", {
                              attrs: {
                                label: _vm.$t(
                                  "business.interesting.HRM_PAYROLL"
                                ),
                                value: "HRM_PAYROLL"
                              },
                              model: {
                                value: _vm.form.interesting.HRM_PAYROLL,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.interesting,
                                    "HRM_PAYROLL",
                                    $$v
                                  )
                                },
                                expression: "form.interesting.HRM_PAYROLL"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("BaseCheckbox", {
                          attrs: {
                            label: _vm.$t("business.interesting.REPORT"),
                            value: "REPORT"
                          },
                          model: {
                            value: _vm.form.interesting.REPORT,
                            callback: function($$v) {
                              _vm.$set(_vm.form.interesting, "REPORT", $$v)
                            },
                            expression: "form.interesting.REPORT"
                          }
                        }),
                        _vm._v(" "),
                        _c("BaseCheckbox", {
                          attrs: {
                            label: _vm.$t(
                              "business.interesting.USER_PERMISSION"
                            ),
                            value: "USER_PERMISSION"
                          },
                          model: {
                            value: _vm.form.interesting.USER_PERMISSION,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form.interesting,
                                "USER_PERMISSION",
                                $$v
                              )
                            },
                            expression: "form.interesting.USER_PERMISSION"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-6" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-block",
                      attrs: {
                        disabled: _vm.form.shop_name.trim().length == 0,
                        type: "submit"
                      },
                      on: {
                        click: function($event) {
                          _vm.progress.active = 1
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("button.next")) +
                          "\n            "
                      ),
                      _c("i", {
                        staticClass: "fas fa-angle-right",
                        staticStyle: { position: "relative", top: "1px" }
                      })
                    ]
                  )
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.progress.active == 1
        ? [
            _c("div", { staticClass: "col-md-6 form" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("message.email")))]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.email,
                      expression: "form.email"
                    }
                  ],
                  ref: "email",
                  staticClass: "form-control",
                  class: [{ "is-invalid": _vm.state.is_invalid_email }],
                  attrs: {
                    disabled:
                      _vm.$store.state.app.loading == true || _vm.disabledForm,
                    type: "email"
                  },
                  domProps: { value: _vm.form.email },
                  on: {
                    keyup: function($event) {
                      _vm.form.email.trim().length == 0
                        ? (_vm.state.is_invalid_email = true)
                        : (_vm.state.is_invalid_email = false)
                    },
                    change: function($event) {
                      !_vm.validateEmail(_vm.form.email)
                        ? (_vm.state.is_invalid_email = true)
                        : (_vm.state.is_invalid_email = false)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "email", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "invalid-feedback" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.emailisinvalid")) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("message.password")))]),
                  _vm._v(" "),
                  [
                    _vm.browser.name == "chrome"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.password,
                              expression: "form.password"
                            }
                          ],
                          staticClass: "form-control text-security",
                          class: [
                            { "is-invalid": _vm.state.is_invalid_password }
                          ],
                          attrs: {
                            disabled:
                              _vm.$store.state.app.loading == true ||
                              _vm.disabledForm,
                            type: "text"
                          },
                          domProps: { value: _vm.form.password },
                          on: {
                            change: function($event) {
                              _vm.form.password.trim().length < 6
                                ? (_vm.state.is_invalid_password = true)
                                : (_vm.state.is_invalid_password = false)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "password",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.password,
                              expression: "form.password"
                            }
                          ],
                          staticClass: "form-control",
                          class: [
                            { "is-invalid": _vm.state.is_invalid_password }
                          ],
                          attrs: {
                            disabled:
                              _vm.$store.state.app.loading == true ||
                              _vm.disabledForm,
                            type: "password"
                          },
                          domProps: { value: _vm.form.password },
                          on: {
                            change: function($event) {
                              _vm.form.password.trim().length < 6
                                ? (_vm.state.is_invalid_password = true)
                                : (_vm.state.is_invalid_password = false)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "password",
                                $event.target.value
                              )
                            }
                          }
                        })
                  ],
                  _vm._v(" "),
                  _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("message.passwordmustbeatleast6characters")
                        ) +
                        "\n        "
                    )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {},
                [
                  _c(
                    "vs-checkbox",
                    {
                      staticStyle: {
                        "justify-content": "left",
                        margin: "0",
                        "font-size": "var(--font-size)"
                      },
                      attrs: {
                        disabled:
                          _vm.$store.state.app.loading == true ||
                          _vm.disabledForm,
                        vsValue: true
                      },
                      model: {
                        value: _vm.form.agree_terms,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "agree_terms", $$v)
                        },
                        expression: "form.agree_terms"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("message.iagreeterms")) +
                          "\n          "
                      ),
                      _c(
                        "a",
                        {
                          staticStyle: {
                            position: "relative",
                            "z-index": "999999"
                          },
                          attrs: {
                            href: "https://www.treesoft.io/th/terms",
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("message.terms")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              !_vm.isSubmitted
                ? _c("div", { staticClass: "form-row mt-3" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-block",
                          attrs: {
                            disabled: _vm.$store.state.app.loading,
                            type: "submit"
                          },
                          on: {
                            click: function($event) {
                              _vm.progress.active = 0
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-angle-left",
                            staticStyle: { position: "relative", top: "1px" }
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("button.prev")) +
                              "\n          "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-web btn-block",
                          attrs: {
                            disabled: _vm.disabledRegister,
                            type: "submit"
                          },
                          on: {
                            click: function($event) {
                              return _vm.register()
                            }
                          }
                        },
                        [
                          _vm.$store.state.app.loading
                            ? _c("span", [
                                _c("i", { staticClass: "fas fa-spinner spin" })
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("message.login")))
                              ])
                        ]
                      )
                    ])
                  ])
                : _c(
                    "div",
                    {
                      staticClass:
                        "form-row d-flex flex-column align-items-center justify-content-center mt-3"
                    },
                    [
                      _c("CircleProgress", {
                        attrs: {
                          percent: _vm.myLoading.progress,
                          size: 60,
                          viewport: true,
                          showPercent: false,
                          borderBgWidth: 5,
                          borderWidth: 5,
                          fillColor: "#A3CA76"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "mt-2 text-center",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("message.registerloading"))
                        }
                      })
                    ],
                    1
                  )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.progress.active == null
        ? [
            _c("div", { staticClass: "col-md-6 form" }, [
              _c("p", { staticClass: "text-success text-center" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.registersuccess")) + " "
                ),
                _c("i", { staticClass: "far fa-check-circle" })
              ]),
              _vm._v(" "),
              _vm._m(1)
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.progress.active == 0
        ? _c(
            "div",
            { staticClass: "col-md-12 text-center mb-4" },
            [
              _c(
                "p",
                { staticClass: "text-white mb-1" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("message.alreadyaccount")) +
                      "\n      "
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "text-white",
                      attrs: {
                        to: {
                          name: "SignIn",
                          query: Object.assign({}, _vm.$route.query)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.login")) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("DropdownLang")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.progress.active == null
        ? _c("div", { staticClass: "col-md-12 text-center mb-4" }, [
            _c(
              "p",
              { staticClass: "text-white mb-1" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-white",
                    attrs: {
                      to: {
                        name: "SignIn",
                        query: {
                          token: _vm.form.token
                        }
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.login")) +
                        "\n      "
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo col-md-12 text-center" }, [
      _c("img", { attrs: { src: require("./../../assets/logo-10.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fb-page",
        attrs: {
          "data-href": "https://www.facebook.com/treesoft.io",
          "data-tabs": "",
          "data-width": "",
          "data-height": "",
          "data-small-header": "true",
          "data-adapt-container-width": "true",
          "data-hide-cover": "true",
          "data-show-facepile": "false"
        }
      },
      [
        _c(
          "blockquote",
          {
            staticClass: "fb-xfbml-parse-ignore",
            attrs: { cite: "https://www.facebook.com/treesoft.io" }
          },
          [
            _c(
              "a",
              { attrs: { href: "https://www.facebook.com/treesoft.io" } },
              [_vm._v("TreeSoft.io")]
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2ae4eec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2ae4eec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/SignUp.vue
// module id = null
// module chunks = 